<template>
  <div class="mod"
       style="z-index: 9999">
    <div class="box">
      <img
        class="largeIcon"
        src="/static/img/时间.svg"
        data-src="/static/img/时间.svg"
        alt="largeIcon"
      />
      <span class="info">
      短信已发送，等待签署
    </span>
      <span class="summary">
      请点击短信链接，根据提示在支付宝中完成签署，如果未收到短信，可尝试点击按钮重新发送
    </span>
      <div :class="resendTime !== 0 ? 'bd' : 'submain'"
           @click="counter">
      <span class="tag">
        重新发送短信
        <span v-if="resendTime !== 0">
          （{{ resendTime }}）
        </span>
      </span>
      </div>
      <div class="submain"
           @click="checkOrderStatus">
      <span class="tag" >
        我已完成签署
      </span>
      </div>
      <div class="submain"
           v-if="this.$route.query.canShow"
           @click="returnAuthenticationHome" style="background: #FFFFFF;border-radius: 44px;border: 1px solid #5878FA;">
     <span class="tag" style="color: #5878FA" >
        返回修改信息
      </span>
      </div>
    </div>
  </div>
</template>
<script>
  // import $ from 'jquery'
  import wx from 'wx'
  import {mapGetters, mapState} from 'vuex'
  import emkt from '../../emkt.js'
  export default {
    data () {
      return {
        coolDown: false,
        resendTime: 0
      }
    },
    computed: {
      ...mapGetters([
        'hasLogin', 'isWapp'
        // ...
      ]),
      ...mapState([
        'sessionInfo'
      ])
    },
    mounted () {
      console.log(this.$route, 'sssssssssssssssss')
      this.$route.query.time ? this.counterWithoutSend() : ''
    },
    methods: {
      fetchData () {
        if (this.$route.params.authenticationInfo) {
          this.sendAuthenticationMesage()
        }
      },
      sendAuthenticationMesage () {
        this.$weui.loading('正在发送短信')
        this.gcapi('startEmktSignFlowByCustomer', this.$route.params.authenticationInfo)
            .then((response) => {
              this.$weui.loading().hide()
              if (response.body.message !== '') {
                this.$weui.toast(response.body.message, 3000)
              } else {
                this.$weui.toast('短信已经发送！', 3000)
              }
            }, (response) => {
              this.$weui.toast(response.body.message, 2500)
            })
      },
      revert () {
        emkt.setLocalStorage('authenticationSource', null)
        if (emkt.isWapp) {
          wx.miniProgram.switchTab({
            url: '/pages/index/index'
          })
        } else {
          this.$router.replace({ name: 'home' })
        }
      },
      returnAuthenticationHome () {
        this.$router.back()
      },
      counterWithoutSend () {
        clearInterval(countTime)
        this.resendTime = 60
        let countTime = setInterval(() => {
          if (this.resendTime > 0) {
            this.resendTime--
          } else {
            clearInterval(countTime)
          }
        }, 1000)
      },
      counter () {
        clearInterval(countTime)
        this.sendAuthenticationMesage(true)
        this.resendTime = 60
        let countTime = setInterval(() => {
          if (this.resendTime > 0) {
            this.resendTime--
          } else {
            clearInterval(countTime)
          }
        }, 1000)
      },
      checkOrderStatus () {
        this.gcapi('getWaitPayOrderInfoByOrderId', parseInt(this.$route.query.orderId)).then(res => {
          if (res.body.code === 0) {
            let signStatus = res.body.result.signStatus
            if (signStatus === 2) {
              this.$router.replace({name: 'WeappSuccessPay', params: {orderId: this.orderId}})
            } else {
              this.$weui.dialog({
                content: '您还未完成签署',
                buttons: [{
                  label: '我知道了'
                }]
              })
            }
          } else {
            alert('获取电签状态失败，请检查你的网络或联系客服！')
          }
        })
      }
    }
  }
</script>

<style scoped>

  .mod {
    height: 812px;
  }

  .box {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #fafafa;
    height: 812px;
    overflow: hidden;
  }

  .hd {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    background-color: #ffffff;
    width: 375px;
    height: 88px;
  }

  .container {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 14px;
    margin-left: 34px;
    height: 19px;
  }

  .txt {
    margin-right: 232px;
    max-width: 248px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 15px;
    letter-spacing: 0px;
    white-space: nowrap;
    color: #ffffff;
    font-family: SFProText-Semibold, SF Pro Text;
    font-size: 15px;
    font-weight: 600;
  }

  .outer {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: -1px;
  }

  .icon {
    margin-right: 5px;
    width: 17px;
    height: 12px;
  }

  .icon_1 {
    margin-right: 5px;
    width: 16px;
    height: 12px;
  }

  .wrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    border-color: rgba(255, 255, 255, 0.35);
    width: 22px;
    height: 11px;
  }

  .color {
    border-radius: 1px;
    background-color: #ffffff;
    width: 18px;
    height: 7px;
  }

  .dot {
    width: 2px;
    height: 4px;
  }

  .block {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 17px;
    margin-left: 17px;
  }

  .icon_2 {
    margin-right: 128px;
    width: 9px;
    height: 18px;
  }
  .word {
    margin-right: 60px;
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }

  .block_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-style: solid;
    border-radius: 16px;
    border-color: rgba(151, 151, 151, 0.2);
    background-color: rgba(255, 255, 255, 0.6);
    height: 32px;
  }

  .block_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    width: 44px;
  }

  .icon_3 {
    width: 19px;
    height: 7px;
  }

  .colorDiv {
    margin-right: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    width: 1px;
    height: 18px;
  }

  .group {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 41px;
  }

  .icon_4 {
    width: 18px;
    height: 18px;
  }

  .largeIcon {
    position: relative;
    margin-top: 105px;
    width: 61px;
    height: 61px;
  }

  .info {
    position: relative;
    margin-top: 19px;
    max-width: 287px;
    height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 28px;
    white-space: nowrap;
    color: #424242;
    font-size: 20px;
    font-weight: 400;
  }

  .summary {
    webkit-box-orient: vertical;
    display: -webkit-inline-box;
    webkit-line-clamp: 2;
    position: relative;
    margin-top: 10px;
    width: 276px;
    height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
  }

  .bd {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
    border-radius: 22px;
    background-color: rgba(88, 120, 250, 0.5);
    width: 325px;
    height: 44px;
    pointer-events: none;
  }
  .submain {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
    border-radius: 22px;
    background-color: #5878fa;
    width: 325px;
    height: 44px;
  }

  .button {
    max-width: 313px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

  .tag {
    max-width: 313px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

  .row {
    background-color: #fafafa;
    width: 375px;
    height: 812px;
    overflow: hidden;
    display: flex;
    position: relative;
    align-items: center;
    margin-top: 20px;
  }

  .row1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 20px;
  }

  .largeIcon_1 {
    width: 60px;
    height: 60px;
  }

  .row2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 28px;
    position: relative;
    margin-top: 20px;
  }

  .info_1 {
    line-height: 20px;
    white-space: nowrap;
    color: #424242;
    font-size: 20px;
    font-weight: 400;
  }

  .row3 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-radius: 22px;
    background-color: #5878fa;
    width: 325px;
    height: 44px;
    position: relative;
    margin-top: 20px;
  }

  .tag_1 {
    max-width: 313px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

  .row4 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 17px;
    position: relative;
    margin-top: 20px;
  }

  .info_2 {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row5 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 17px;
    position: relative;
    margin-top: 20px;
  }

  .info_3 {
    line-height: 12px;
    white-space: nowrap;
    color: #67c08c;
    font-size: 12px;
    font-weight: 600;
  }

  .row6 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 17px;
    position: relative;
    margin-top: 20px;
  }

  .info_4 {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row7 {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #ffffff;
    width: 375px;
    height: 88px;
    position: relative;
    margin-top: 20px;
  }

  .group_1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 14px;
    margin-left: 34px;
    height: 19px;
  }

  .text {
    margin-right: 232px;
    max-width: 248px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 15px;
    letter-spacing: 0px;
    white-space: nowrap;
    color: #ffffff;
    font-family: SFProText-Semibold, SF Pro Text;
    font-size: 15px;
    font-weight: 600;
  }

  .group_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: -1px;
  }

  .icon_5 {
    margin-right: 5px;
    width: 17px;
    height: 12px;
  }

  .icon_6 {
    margin-right: 5px;
    width: 16px;
    height: 12px;
  }

  .container_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    border-color: rgba(255, 255, 255, 0.35);
    width: 22px;
    height: 11px;
  }

  .colorDiv_1 {
    border-radius: 1px;
    background-color: #ffffff;
    width: 18px;
    height: 7px;
  }

  .dot_1 {
    width: 2px;
    height: 4px;
  }

  .container_2 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 17px;
    margin-left: 17px;
  }

  .icon_7 {
    margin-right: 128px;
    width: 9px;
    height: 18px;
  }

  .txt_1 {
    margin-right: 60px;
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }

  .container_3 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-style: solid;
    border-radius: 16px;
    border-color: rgba(151, 151, 151, 0.2);
    background-color: rgba(255, 255, 255, 0.6);
    height: 32px;
  }

  .outer_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    width: 44px;
  }

  .icon_8 {
    width: 19px;
    height: 7px;
  }

  .color_1 {
    margin-right: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    width: 1px;
    height: 18px;
  }

  .wrap_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 41px;
  }

  .icon_9 {
    width: 18px;
    height: 18px;
  }

  .row8 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-width: 1px;
    border-style: solid;
    border-radius: 22px;
    border-color: #5878fa;
    background-color: #ffffff;
    width: 325px;
    height: 44px;
    position: relative;
    margin-top: 20px;
  }

  .tag_2 {
    max-width: 313px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 14px;
    font-weight: 400;
  }

  .submain_1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
    border-width: 1px;
    border-style: solid;
    border-radius: 22px;
    border-color: #5878fa;
    background-color: #ffffff;
    width: 325px;
    height: 44px;
  }

  .tag_3 {
    max-width: 313px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 14px;
    font-weight: 400;
  }

  .row10 {
    background-color: #fafafa;
    width: 375px;
    height: 812px;
    overflow: hidden;
    display: flex;
    position: relative;
    align-items: center;
    margin-top: 20px;
  }

  .main {
    border-style: solid;
    border-color: #efeef3;
    background-color: #ffffff;
    width: 1px;
    height: 131px;
    display: flex;
    position: relative;
    align-items: center;
    margin-top: 20px;
  }

  .row11 {
    border-style: solid;
    border-radius: 10px;
    border-color: #efeef3;
    background-color: #ffffff;
    width: 355px;
    height: 121px;
    display: flex;
    position: relative;
    align-items: center;
    margin-top: 20px;
  }

  .row12 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .txt_2 {
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
  }

  .row13 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .word_1 {
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
  }

  .row14 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .phone {
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .row15 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .txt_3 {
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .row16 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 20px;
  }

  .empty {
    margin-right: 340px;
    width: 0;
    height: 1px;
  }

  .bgWrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 0;
  }

  .bg {
    margin-left: -340px;
    width: 340px;
    height: 1px;
  }

  .row17 {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    margin-top: 20px;
  }

  .div {
    position: relative;
    width: 375px;
    height: 0;
  }

  .group_3 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 1px;
    width: 375px;
  }

  .bg_1 {
    position: relative;
    margin-top: -1px;
    width: 375px;
    height: 1px;
  }

  .outer_2 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    margin-top: 72px;
    background-color: #ffffff;
    width: 375px;
    height: 50px;
  }

  .color_2 {
    margin-top: 37px;
    border-radius: 2px;
    background-color: #000000;
    width: 134px;
    height: 5px;
  }

  .block_3 {
    display: flex;
    position: absolute;
    top: 0;
    align-items: flex-start;
    align-self: center;
    flex-direction: column;
    background-color: #ffffff;
    width: 375px;
    height: 86px;
  }

  .block_4 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    margin-top: 14px;
    height: 15px;
  }

  .info_5 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .text_1 {
    margin-top: 1px;
    line-height: 10px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 10px;
    font-weight: 400;
  }

  .info_6 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .word_2 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 10px;
    font-weight: 400;
  }

  .info_7 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .tagWrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 12px;
    margin-left: 15px;
    border-radius: 22px;
    background-color: #5878fa;
    width: 350px;
    height: 44px;
  }

  .tag_4 {
    max-width: 338px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

  .row18 {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #ffffff;
    width: 375px;
    height: 88px;
    position: relative;
    margin-top: 20px;
  }

  .container_4 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 17px;
    margin-left: 34px;
  }

  .word_3 {
    margin-top: 7px;
    margin-right: 232px;
    max-width: 248px;
    height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 19px;
    letter-spacing: 0px;
    white-space: nowrap;
    color: #ffffff;
    font-family: SFProText-Semibold, SF Pro Text;
    font-size: 15px;
    font-weight: 600;
  }

  .group_4 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
  }

  .icon_10 {
    margin-right: 5px;
    width: 17px;
    height: 12px;
  }

  .icon_11 {
    margin-right: 5px;
    width: 16px;
    height: 12px;
  }

  .container_5 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    border-color: rgba(255, 255, 255, 0.35);
    width: 22px;
    height: 11px;
  }

  .colorDiv_2 {
    border-radius: 1px;
    background-color: #ffffff;
    width: 18px;
    height: 7px;
  }

  .dot_2 {
    width: 2px;
    height: 4px;
  }

  .block_5 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 7px;
    margin-left: 17px;
  }

  .icon_12 {
    margin-right: 128px;
    width: 9px;
    height: 18px;
  }

  .text_2 {
    margin-right: 60px;
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }

  .container_6 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-style: solid;
    border-radius: 16px;
    border-color: rgba(151, 151, 151, 0.2);
    background-color: rgba(255, 255, 255, 0.6);
    height: 32px;
  }

  .outer_3 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    width: 44px;
  }

  .icon_13 {
    width: 19px;
    height: 7px;
  }

  .color_3 {
    margin-right: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    width: 1px;
    height: 18px;
  }

  .wrap_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 41px;
  }

  .icon_14 {
    width: 18px;
    height: 18px;
  }

  .row19 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 20px;
  }

  .icon_15 {
    width: 13px;
    height: 16px;
  }

  .row20 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 20px;
  }

  .icon_16 {
    width: 15px;
    height: 16px;
  }

  .row21 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .info_8 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row22 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .word_4 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row23 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .info_9 {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row24 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .txt_4 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row25 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .info_10 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row26 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .info_11 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row27 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .organization {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row28 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .word_5 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row29 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .text_3 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .ft {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 20px;
  }

  .desc {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

</style>



// WEBPACK FOOTER //
// sendAuthentication.vue?6279b1c2